window.handleNavigation = (e) => ({
    mobileMenuOpen: false,
    lastFocused: null,
    lastInteraction: 'keyboard',
    hideStickyHeader: false,
    headerSticky: false,
    lastScrollTop: 0,
    menuOverlay: null,
    html: null,
    initialHeaderHeight: 0,

    init() {
      this.menuOverlay = document.getElementById('mobile_menu_wrapper');
      this.html = document.documentElement;

      // Only want to compute this on first page load
      this.initialHeaderHeight = document.querySelector('.global-header-container').offsetHeight;

      this.checkShouldHideHeader();
      this.setUpAnimations();
      this.handleBgColor(this.menuOverlay);
    },

    checkShouldHideHeader() {
        let scrollTop = window.pageYOffset || window.scrollY;

        if (scrollTop >= this.initialHeaderHeight && scrollTop > this.lastScrollTop) {
            this.hideStickyHeader = true;
        } else {
            this.hideStickyHeader = false;
        }

        this.headerSticky = scrollTop >= this.initialHeaderHeight;

        this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    },

    handleBgColor(element) {
      setRandomBg(element);
    },

    openMenu() {
      this.html.classList.add('nav-open');
      this.mobileMenuOpen = true;
    },

    closeMenu() {
      this.html.classList.remove('nav-open');
      this.mobileMenuOpen = false;
      resetBg(this.menuOverlay);
      this.$nextTick(() => this.handleBgColor(this.menuOverlay) );
    },

    setUpAnimations() {
      let delayMultiplier = 1;
      let baseDelay = 300;
      const menuItems = document.querySelectorAll('.mobile-menu-wrapper .main-menu > .menu-item > .menu-link');

      menuItems?.forEach(item => {
        let delay = 100 * delayMultiplier + baseDelay;
        item.style.animationDelay = `${delay}ms`;

        delayMultiplier = delayMultiplier + 1;
      });
    }
});

const colors = [
  'bg-orange',
  'bg-yellow',
  'bg-turquoise',
  'bg-purple-300'
];

function chooseColor(colors, historySize = 3) {
  let bag = colors.slice(0);
  let history = [];

  return function() {
    if (bag.length === 0) {
      bag = colors.filter(c => !history.includes(c));
      if(bag.length === 0) bag = colors.slice();
    }

    const index = Math.floor(Math.random() * bag.length);
    const item = bag.splice(index, 1)[0];

    history.push(item);

    if(history.length > historySize) {
      history.shift();
    }

    return item;
  };
}

const pickBgClass = chooseColor(colors, 3);

const setRandomBg = (element) => {
  const pick = pickBgClass();
  element.classList.add(pick.trim());
};

const resetBg = (element) => {
  element.classList.remove(...colors);
};
